import styled, { css } from '../../config/theme'

const StyledForm = styled.form<{ horizontal?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 -10px;
  ${props => props.horizontal ? css`
    @media screen and (min-width: 1000px) {
      flex-direction: row; 
      flex-wrap: nowrap;
    }
  ` : ''}
`

const FieldContainer = styled.div<{ size?: number }>`
  width: ${props => props.size ? props.size * 100 : 100}%;

  padding: 10px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: ${props => props.theme.mediaQueries.form}) {
    width: 100%;
  }
`

export {
  StyledForm,
  FieldContainer,
}
